<template>
  <div id="swiper-ocean-container" class="" data-type="layout">
  	<swiper id="swiper-ocean" :options="swiperOption" ref="problemsOcean" class="span-swiper span-swiper-full span-full full-transitions bgblue">
      <swiper-slide>
      	<div class="full-inner">
        	<h2 class="full-title content-650">{{title}}</h2>
      	</div>
      </swiper-slide>
      <swiper-slide>
      	<div class="full-inner content-750">
    			<h3 class="full-title white">{{slider[0].title}}</h3>
    			<div class="entry-content pt3" v-html="slider[0].content"></div>
      	</div>
      </swiper-slide>
      <swiper-slide>
      	<div class="full-inner content-750">
    			<h3 class="full-title white">{{slider[1].title}}</h3>
    			<div class="entry-content pt3" v-html="slider[1].content"></div>
      	</div>
      </swiper-slide>
      <div class="swiper-button-prev" slot="button-prev" ></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </swiper>
     <ul id="scene" class="scene" data-friction-x="0.1" data-friction-y="0.1" data-scalar-x="4">
        <li class="layer turtle" data-depth="0.30"><img v-bind:class="{'active': swiperOption.currentSlide == 1}" src="/static/images/problems-ocean-turtle.svg"></li>
        <li class="layer fish1" data-depth="-0.50"><img v-bind:class="{'active': swiperOption.currentSlide == 1}"  src="/static/images/problems-ocean-fish1.svg"></li>
        <li class="layer bottle" data-depth="0.40"><img v-bind:class="{'active': swiperOption.currentSlide == 1}"  src="/static/images/problems-ocean-bottle.svg"></li>
        <li class="layer fish2" data-depth="0.60"><img v-bind:class="{'active': swiperOption.currentSlide == 1}"  src="/static/images/problems-ocean-fish2.svg"></li>
        <li class="layer fish3" data-depth="0.80"><img v-bind:class="{'active': swiperOption.currentSlide == 1}"  src="/static/images/problems-ocean-fish3.svg"></li>
        <li class="layer bag" data-depth="-0.90"><img v-bind:class="{'active': swiperOption.currentSlide == 1}"  src="/static/images/problems-ocean-bag.svg"></li>
        <li class="layer fork" data-depth="0.70"><img v-bind:class="{'active': swiperOption.currentSlide == 1}"  src="/static/images/problems-ocean-fork.svg"></li>

        <li class="layer fish4" data-depth="0.30"><img v-bind:class="{'active': swiperOption.currentSlide == 2}"  src="/static/images/problems-ocean-fish3.svg"></li>
        <li class="layer fish5" data-depth="0.30"><img v-bind:class="{'active': swiperOption.currentSlide == 2}"  src="/static/images/problems-ocean-fish1.svg"></li>
        <li class="layer fish6" data-depth="0.30"><img v-bind:class="{'active': swiperOption.currentSlide == 2}"  src="/static/images/problems-ocean-fish4.svg"></li>
        <li class="layer fish7" data-depth="0.30"><img v-bind:class="{'active': swiperOption.currentSlide == 2}"  src="/static/images/problems-ocean-fish5.svg"></li>
        <li class="layer bottle2" data-depth="0.40"><img v-bind:class="{'active': swiperOption.currentSlide == 2}"  src="/static/images/problems-ocean-bottle.svg"></li>
        <li class="layer bottle3" data-depth="-0.40"><img v-bind:class="{'active': swiperOption.currentSlide == 2}"  src="/static/images/problems-ocean-bottle.svg"></li>
        <li class="layer fork2" data-depth="0.70"><img v-bind:class="{'active': swiperOption.currentSlide == 2}"  src="/static/images/problems-ocean-fork.svg"></li>

      </ul>
    <canvas id="bubbles"></canvas>
    <a href="#" data-index="1" class="read-more">
      <span class="arrow-down"></span>
    </a>
  </div>
</template>
<script>
  import misc from '../js/scripts.js'
  import parallax from  '../js/parallax.min.js'
  import ocean from  '../js/Problems-planet-ocean.js'
  
	export default {
		name: 'problems-ocean',
		data() {
	    return {
        self: this,
        title: '',
        slider: [{
          title: '',
          content: ''
        }, { 
          title: '', 
          content: ''
        }],
	      swiperOption: {
          notNextTick: true,
          loop:true,
          updateTranslate: true,
          direction : 'horizontal',
          prevButton:'.swiper-button-prev',
          nextButton:'.swiper-button-next',
          observeParents:true,
          debugger: true,
          speed: 600,
          autoplay: 0,
          paginationClickable :false,
          currentSlide: 0,
          onSlideChangeStart(s){
            if( 'ontouchstart' in window || navigator.maxTouchPoints || misc.get_viewport().width < 560 ){
              var activeSlideHeight = s.slides[s.activeIndex].querySelector('.full-inner').getBoundingClientRect().height + 'px';
              s.container[0].style.height = activeSlideHeight
            }
            this.currentSlide = s.realIndex;
          }
        }
	    }
	  },
    computed: {
      swiper() {
        return this.$refs.problemsOcean.swiper
      }
    },
    methods: {
      getUrl(){
        if( localStorage.getItem('language') === 'en' ){
          return process.env.site.url + '/wp-json/wp/v2/pages?slug=problems-oceans'
        } else {
          return process.env.site.url + '/wp-json/wp/v2/pages?slug=problemas-oceanos&lang=es'
        }
      },
      loadContent(){
        var getUrl = this.getUrl()
        this.axios.get(this.getUrl()).then((response) => {
          var page = response.data[0]
          this.title = page.acf.title
          this.slider = page.acf.slider
          misc.addArrows()
        })
      }
    },
    watch: {
      '$route': 'loadContent'
    },
    mounted(){
      this.$nextTick( () => {
        this.loadContent()
      })

      ocean.initBubbles()
      ocean.parallax()
    }
	}
</script>


// WEBPACK FOOTER //
// Problems-ocean.vue?06c01146